import { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { KModal } from '@/ui-library/components/molecules/KModal';
import { KText } from '@/ui-library/components/text';
import {
  notifyAdminCredits,
  CREDIT_MANAGEMENT_PATH,
} from './backgroundCheckApi';
import { useShowToast } from '@/hooks';
import { useKFlags } from '@/hooks/use-k-flags';

export const InsufficientCreditsModal = ({ isOpen, onClose, capError }) => {
  const [isNotifying, setIsNotifying] = useState(false);
  const toast = useShowToast();
  const history = useHistory();
  const { tUnifiedCreditManagement } = useKFlags();
  const canNotifyAdmin = !capError?.user_has_manage_org_fraud_detector;
  const reminderSent = capError?.reminder_sent_recently;

  // Admins go to credit management to top up only once unified credit
  // management is live; otherwise fall back to the Pylon support chat.
  const adminCtaLabel = tUnifiedCreditManagement
    ? 'Top up credits'
    : 'Contact support';
  const handleAdminCta = () => {
    if (tUnifiedCreditManagement) {
      history.push(CREDIT_MANAGEMENT_PATH);
    } else {
      (window as unknown as { Pylon?: (_cmd: string) => void }).Pylon?.('show');
    }
    onClose();
  };

  const handleNotifyAdmin = async () => {
    setIsNotifying(true);
    try {
      await notifyAdminCredits();
      toast({ title: 'Admin has been notified about insufficient credits' });
      onClose();
    } catch {
      toast({ title: 'Failed to notify admin', status: 'error' });
    } finally {
      setIsNotifying(false);
    }
  };

  return (
    <KModal
      isOpen={isOpen}
      onClose={onClose}
      title="Insufficient credits"
      ctaLabel={
        canNotifyAdmin
          ? reminderSent
            ? 'Admin notified'
            : 'Notify admin'
          : adminCtaLabel
      }
      hideCloseButton={true}
      ctaAction={canNotifyAdmin ? handleNotifyAdmin : handleAdminCta}
      isCtaLoading={isNotifying}
      ctaButtonProps={canNotifyAdmin ? { isDisabled: reminderSent } : {}}
      enableCancelBtn={canNotifyAdmin}
      modalContentProps={{ borderRadius: '4px' }}
      modalFooterProps={{
        borderTop: '1px solid',
        borderColor: 'secondary-200',
        pt: '12px',
      }}
    >
      <KText color="secondary-700" mb="12px">
        You don&apos;t have enough credits to review this candidate with fraud
        detector
        {!canNotifyAdmin &&
          (tUnifiedCreditManagement
            ? '. Top up to add more credits.'
            : '. Contact support for more credits.')}
      </KText>
    </KModal>
  );
};
